var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),(_vm.isShowBasket)?_c('tr-modal',{attrs:{"small":"true"},on:{"close":_vm.closeBasket}},[_c('sample-basket',{staticClass:"sample-basket-modal",attrs:{"show-button":"true"}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }